import React from "react";
import { ASSETS } from "../../data/site";
import { PhoneFrame } from "./PhoneFrame";
import { Reveal } from "./Reveal";

export const CommunityWatch = () => (
  <section
    id="community-watch"
    className="relative py-24 md:py-32"
    data-testid="community-watch-section"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid items-center gap-14 md:grid-cols-2 md:gap-16">
        <Reveal className="order-2 md:order-1">
          <div className="relative flex items-end justify-center">
            <img
              src={ASSETS.communityLifestyle}
              alt="A diverse group of women connected and looking out for one another"
              loading="lazy"
              className="w-[58%] max-w-[300px] rounded-[2rem] border-4 border-white object-cover shadow-[0_24px_55px_rgba(47,94,67,0.2)]"
              style={{ aspectRatio: "3/4" }}
              data-testid="community-lifestyle-image"
            />
            <div className="relative z-10 -ml-10 mb-4 sm:-ml-14">
              <PhoneFrame
                src={ASSETS.communityWatch}
                alt="SisterSafe Community Watch screen showing all clear nearby"
                testId="community-watch-mockup"
                buttons={false}
                className="w-[148px] sm:w-[176px]"
              />
            </div>
          </div>
        </Reveal>

        <div className="order-1 md:order-2">
          <Reveal>
            <p className="text-sm font-semibold uppercase tracking-[0.15em] text-[#8AA583]">
              Community Watch
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-heading mt-4 text-3xl font-semibold leading-tight tracking-tight text-[#111E16] md:text-4xl">
              Know what's happening before you get there.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-4 text-lg leading-relaxed text-[#4A5F52]">
              Receive anonymized safety reports from verified women nearby. When everything
              is clear, you'll know that too, giving you confidence wherever you go.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
